import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Button } from '@blueprintjs/core';
import ReactMarkdown from 'react-markdown';
import ReactMde from 'react-mde';
import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from "showdown";

@withRouter
@inject("store")
@observer
export default class Recommend extends Component
{

     
   
   
   

    render()
    {
        return <div className="notepage">
              
                <div className="contentbox">
                 
                    <ReactMarkdown source={this.props.store.current_note_markdown} />
                 
                    
                </div>
            </div>;
    }
}